import type { ReactElement } from 'react';

import { Badge, Card, CardContent, CardHeader, CardTitle } from '@govard/ui-primitives';

import type { StructuredMessagePayload } from '@govard/ai-chat-kit';

interface ScenarioSnippetProps {
  scenario: Extract<StructuredMessagePayload, { type: 'scenario' }>['scenario'];
}

export function ScenarioSnippet({ scenario }: ScenarioSnippetProps): ReactElement {
  return (
    <Card data-testid="structured-snippet-scenario">
      <CardHeader>
        <CardTitle>{scenario.name}</CardTitle>
      </CardHeader>
      <CardContent className="flex flex-wrap gap-2 text-sm">
        {scenario.status ? <Badge variant="secondary">{scenario.status}</Badge> : null}
      </CardContent>
    </Card>
  );
}
